import { RootState } from '../../RootState';
import { WishlistSettings } from '@spa/lib/store/settings/WishlistSettings';

const selectWishlistSettings = (state: RootState): WishlistSettings => {
  const settings = state.settings.settings;

  if (settings === null) {
    throw new Error('Wishlist settings should be initialized.');
  }

  return settings.wishlistSettings;
};

export default selectWishlistSettings;
